import React, { useState } from 'react';
import './Explore.css';

const Explore = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [sortBy, setSortBy] = useState('latest');

  const exploreItems = [
    {
      id: 'tge-event',
      type: 'event',
      title: 'Token Generation Event (TGE)',
      description: 'A token generation event is expected around Q1 2026, following Miden\'s $25 million seed round led by a16z crypto, 1kx, and Hack VC.',
      featured: true,
      status: 'Expected · Q1 2026',
      source: 'Miden / Press',
      externalLink: 'https://polygon.technology/blog/miden-raises-25m-from-a16z-crypto-1kx-and-hackvc-to-build-the-edge-blockchain',
      actionLabel: 'Read Funding Details',
      tags: ['tge', 'token', 'q1-2026', 'funding']
    },
    {
      id: 'mainnet-launch',
      type: 'announcement',
      title: 'Upcoming Mainnet Launch',
      description: 'Miden mainnet launch is pending. Follow updates for roadmap milestones, token launch details, and early access opportunities.',
      featured: false,
      status: 'Planned',
      source: 'Miden',
      externalLink: 'https://twitter.com/0xMiden',
      actionLabel: 'Follow Updates',
      tags: ['mainnet', 'launch', 'miden']
    },
    {
      id: '$25m-seed-funding',
      type: 'announcement',
      title: '$25M Seed Funding Round',
      description: 'Miden closed a $25 million seed round led by a16z crypto, 1kx, and Hack VC, with participation from Polygon Ventures and other investors.',
      featured: false,
      status: 'Completed',
      source: 'Miden / Press',
      externalLink: 'https://polygon.technology/blog/miden-raises-25m-from-a16z-crypto-1kx-and-hackvc-to-build-the-edge-blockchain',
      actionLabel: 'Read Blog Post',
      tags: ['funding', 'investment', 'ecosystem']
    },
    {
      id: 'hybrid-notes',
      type: 'highlight',
      title: 'Hybrid Notes Feature',
      description: 'Hybrid Notes combine account and UTXO models, allowing assets to be both contract-invoked and anonymously transferred.',
      featured: false,
      status: 'Available',
      source: 'Miden Protocol',
      actionLabel: 'Learn More',
      tags: ['feature', 'protocol', 'hybrid-notes']
    },
    {
      id: 'local-proving',
      type: 'highlight',
      title: 'Local Transaction Proving',
      description: 'Miden decentralizes execution and state to the client side, allowing users to generate recursive zk-STARK proofs locally, which are verified on-chain only once.',
      featured: false,
      status: 'Available',
      source: 'Miden Protocol',
      actionLabel: 'Learn More',
      tags: ['feature', 'proving', 'privacy', 'zk-stark']
    },
    {
      id: 'account-abstraction',
      type: 'highlight',
      title: 'Native Account Abstraction',
      description: 'Miden supports native account abstraction, enhancing security and usability with features like multi-signature and social recovery.',
      featured: false,
      status: 'Available',
      source: 'Miden Protocol',
      actionLabel: 'Learn More',
      tags: ['feature', 'account-abstraction', 'security']
    },
    {
      id: 'rust-wasm',
      type: 'highlight',
      title: 'Rust to WASM Contracts',
      description: 'Miden supports Rust to WASM contracts, providing developers with familiar tooling and enhanced security.',
      featured: false,
      status: 'Available',
      source: 'Miden Protocol',
      actionLabel: 'Learn More',
      tags: ['feature', 'rust', 'wasm', 'developers']
    },
    {
      id: 'encrypted-notes',
      type: 'announcement',
      title: 'Planned: Encrypted Notes',
      description: 'Planned encrypted notes will enable end-to-end encrypted transactions, unlocking new privacy-preserving applications.',
      featured: false,
      status: 'Planned',
      source: 'Miden Protocol',
      actionLabel: 'Learn More',
      tags: ['upcoming', 'encryption', 'privacy']
    },
    {
      id: 'vm-architecture',
      type: 'highlight',
      title: 'Miden VM Architecture',
      description: 'Overview of the Miden VM architecture, stack-based execution, and zero-knowledge proof system, and how Miden positions itself as an "edge ZK-rollup" alongside zkSync and StarkNet.',
      featured: false,
      source: 'Docs & Research',
      externalLink: 'https://docs.miden.xyz',
      actionLabel: 'Read Article',
      tags: ['learn', 'architecture', 'technical']
    },
    {
      id: 'community-privacy-intro',
      type: 'community',
      title: 'Join the Privacy Community',
      description: 'Discuss private DeFi, compliant ZK finance, and edge execution with other builders. Connect on Telegram, X, and our Forum.',
      featured: false,
      status: 'Active',
      source: 'Miden Community',
      externalLink: 'https://t.me/BuildOnMiden',
      actionLabel: 'Join Telegram',
      tags: ['community', 'privacy', 'discussion']
    },
    {
      id: 'programmable-privacy',
      type: 'community',
      title: 'Programmable Privacy Network',
      description: 'Deep dive into Miden\'s configurable confidentiality for compliant institutional finance. Learn how programmable privacy allows apps to choose public vs private execution.',
      featured: false,
      status: 'Article',
      source: 'Miden Blog',
      externalLink: 'https://miden.xyz/publications#blog',
      actionLabel: 'Read More',
      tags: ['privacy', 'miden', 'institutional']
    },
    {
      id: 'octra-protocol',
      type: 'community',
      title: 'Octra: Privacy Infrastructure',
      description: 'Octra builds privacy-preserving infrastructure for Web3. Focus on scalable zero-knowledge solutions for enterprise adoption.',
      featured: false,
      status: 'Ecosystem',
      source: 'Web3 Privacy',
      externalLink: 'https://octra.org',
      actionLabel: 'Watch',
      tags: ['octra', 'privacy', 'infrastructure']
    },
    {
      id: 'aztec-network',
      type: 'community',
      title: 'Aztec Network: Encrypted Ethereum',
      description: 'Aztec builds fully encrypted smart contracts on Ethereum using PLONK proofs. Latest updates on Noir language and privacy circuits.',
      featured: false,
      status: 'Ecosystem',
      source: 'Web3 Privacy',
      externalLink: 'https://aztec.network',
      actionLabel: 'Explore',
      tags: ['aztec', 'privacy', 'ethereum']
    },
    {
      id: 'aleo-network',
      type: 'community',
      title: 'Aleo: Zero-Knowledge Applications',
      description: 'Aleo enables private applications using zkSNARKs. Mainnet delivers private DeFi and gaming with Leo programming language.',
      featured: false,
      status: 'Ecosystem',
      source: 'Web3 Privacy',
      externalLink: 'https://aleo.org',
      actionLabel: 'Learn More',
      tags: ['aleo', 'zk-snark', 'private-apps']
    },
    {
      id: 'more-privacy-ecosystems',
      type: 'community',
      title: 'More Privacy Ecosystems',
      description: 'Explore other leading privacy projects: Oasis (confidential computing), Secret Network (encrypted smart contracts), Nym (mixnet privacy), Penumbra (private DEX), and more.',
      featured: false,
      status: 'Ecosystem',
      source: 'Web3 Privacy',
      externalLink: '#',
      actionLabel: 'View All',
      tags: ['ecosystem', 'privacy', 'overview']
    }
  ];

  const typeStyles = {
    announcement: { bg: 'explore-card-announcement', border: 'explore-border-announcement', color: '#3b82f6' },
    event: { bg: 'explore-card-event', border: 'explore-border-event', color: '#a855f7' },
    mint: { bg: 'explore-card-mint', border: 'explore-border-mint', color: '#ec4899' },
    highlight: { bg: 'explore-card-highlight', border: 'explore-border-highlight', color: '#10b981' },
    community: { bg: 'explore-card-community', border: 'explore-border-community', color: '#8b5cf6' }
  };

  const typeMap = {
    'announcements': 'announcement',
    'events': 'event',
    'highlights': 'highlight',
    'community · privacy': 'community',
  };

  const filteredItems = activeFilter === 'All' 
    ? exploreItems 
    : exploreItems.filter(item => {
        const key = activeFilter.toLowerCase();
        const mapped = typeMap[key];
        return mapped ? item.type === mapped : true;
      });

  const sortedItems = [...filteredItems].sort((a, b) => {
    switch (sortBy) {
      case 'latest':
        if (!a.date || !b.date) return 0;
        return new Date(b.date) - new Date(a.date);
      case 'trending':
        return (b.featured ? 1 : 0) - (a.featured ? 1 : 0);
      case 'upcoming':
        if (!a.date || !b.date) return 0;
        return new Date(a.date) - new Date(b.date);
      default:
        return 0;
    }
  });

  const featuredItem = sortedItems.find(item => item.featured);
  const regularItems = sortedItems.filter(item => !item.featured);

  return (
    <div className="explore-page">
      <div className="explore-header">
        <h1>Explore</h1>
        <p>Stay updated on launches, events, and what's happening in the Miden ecosystem.</p>
      </div>

      <div className="filter-bar">
        <div className="filter-buttons">
          {['All', 'Announcements', 'Events', 'Highlights', 'Community · Privacy'].map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveFilter(cat)}
              className={`filter-button ${activeFilter === cat ? 'active' : ''}`}
            >
              {cat}
            </button>
          ))}
        </div>

        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="sort-select"
        >
          <option value="latest">Latest</option>
          <option value="trending">Trending</option>
          <option value="upcoming">Upcoming</option>
        </select>
      </div>

      {featuredItem && (
        <div className="featured-card">
          <div className="featured-badge">FEATURED</div>
          <div className="featured-content">
            <div>
              <h2>{featuredItem.title}</h2>
              <p>{featuredItem.description}</p>
              <div className="featured-actions">
                {featuredItem.externalLink && (
                  <a
                    href={featuredItem.externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="featured-button"
                  >
                    {featuredItem.actionLabel || 'Learn More'} →
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="explore-feed">
        {regularItems.map((item) => {
          const style = typeStyles[item.type] || typeStyles.announcement;
          return (
            <div key={item.id} className={`explore-card ${style.bg} ${style.border}`}>
              <div className="explore-card-header">
                <div className="explore-card-title-section">
                  <div>
                    <span className="explore-card-type">{item.type.toUpperCase()}</span>
                    <h3>{item.title}</h3>
                  </div>
                </div>
                {item.featured && <span className="trending-badge">TRENDING</span>}
              </div>

              <p className="explore-card-description">{item.description}</p>

              <div className="explore-card-meta">
                {item.source && <span>{item.source}</span>}
                {item.status && (
                  <span className="status-badge" style={{ color: typeStyles[item.type]?.color }}>
                    • {item.status}
                  </span>
                )}
              </div>

              <div className="explore-card-actions">
                {item.externalLink && item.externalLink !== '#' ? (
                  <a
                    href={item.externalLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="explore-card-button"
                  >
                    {item.actionLabel || 'Learn More'}
                  </a>
                ) : (
                  <button className="explore-card-button" disabled>
                    {item.actionLabel || 'Learn More'}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Explore;

